<template>
  <div>
    Due to a problem with PoseNet this website is not available right now. Please try it out later.
  </div>
</template>

<script>
export default {
}
</script>
